<button (click)="download()" class="btn-primary">Export to Excel <img src="assets/icons/excel.svg" alt="" ml10></button>
@if (allParticipants) {
  <div panel-list>
    <div registration-list [class.has-selections]="selectedItems.size > 0">
      <div head [attr.mode]="searchmode">
        <div left>
        </div>
        <div right>
          <span><i class="material-icons">hotel</i></span>
          <section>
            <span>Hotel Waitlist</span>
            <span>Innovative Creative Learning (11/04/19 - 11/08/19) • Max Capacity: 400</span>
          </section>
          <span (click)="toggleRegistration()">
            <i class="material-icons">clear</i>
          </span>
        </div>
        <span><i class="material-icons">local_library</i></span>
        <div>Registration Status ( {{acceptedStatusCount}} / {{allParticipants?.length}} )</div>
        <div right-head>
        </div>
        <div class="filter-select-items">
          <div>
            <label for="filter">Filter : </label>
            <select id="filter" [(ngModel)]="selectedFilter" (change)="onFilterChange()">
              <option value="all">All</option>
              <option value="accepted">Accepted</option>
            </select>
          </div>
        </div>
      </div>
      @if (selectedItems.size > 0) {
        <div class="action-banner action-banner--sticky">
          <span class="selection-count">{{ selectedItems.size }} Registrant(s) Selected</span>
          @if (getBulkSelectionSummary()) {
            <span class="selection-summary">({{ getBulkSelectionSummary() }})</span>
          }
          @if (canBulkHide()) {
            <button mat-button class="action-btn action-btn--hide" (click)="bulkHide()">
              <mat-icon>visibility_off</mat-icon> Hide from Attendee Lists
            </button>
          }
          @if (canBulkShow()) {
            <button mat-button class="action-btn action-btn--show" (click)="bulkShow()">
              <mat-icon>visibility</mat-icon> Show in Attendee Lists
            </button>
          }
          <button mat-button class="action-btn action-btn--clear" (click)="clearSelection()">Clear Selection</button>
        </div>
      }
      @if (getFilteredParticipants()?.length) {
        <table class="table-fixedheader" [attr.mode]="mode">
          <thead>
            <th class="edit select-visibility-col" (click)="sort('isUserPrivate', $event)">
              <div>
                <input type="checkbox" aria-label="Select all visible registrants" [checked]="areAllVisibleRowsChecked()" (change)="toggleSelectAll($event)"
                  (click)="$event.stopPropagation()" />
                <span>Visibility</span>
                <i class="material-icons" [ngClass]="{'active': isUserPrivateAsc}"> arrow_drop_down</i>
              </div>
            </th>
            <th class="edit" (click)="sort('lastName', $event)">
              <span>Name</span>
              <i class="material-icons" [ngClass]="{'active':isLastNameAsc}"> arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('email', $event)">
              <span>Email</span>
              <i class="material-icons" [ngClass]="{'active':isEmailAsc}">arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('flightArrival', $event)"><span>Arrival</span>
              <i class="material-icons" [ngClass]="{'active':isFlightArrivalStatusAsc}"> arrow_drop_down</i>
            </th>
            <th class="view">
              <div>
                <div (click)="sort('lastName', $event)">
                  <span>Name</span>
                  <i class="material-icons" [ngClass]="{'active':isLastNameAsc}"> arrow_drop_down</i>
                </div>
                <div (click)="sort('email', $event)">
                  <span>Email</span>
                  <i class="material-icons" [ngClass]="{'active':isEmailAsc}"> arrow_drop_down</i>
                </div>
              </div>
            </th>
            <th class="edit" (click)="sort('flightDeparture', $event)">
              <span>Departure</span>
              <i class="material-icons" [ngClass]="{'active':isFlightDepartureStatusAsc}">arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('inviteeStatus', $event)"><span>Cvent Status</span>
              <i class="material-icons" [ngClass]="{'active':isInviteeStatusAsc}"> arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('registrationType', $event)"><span>Registration Type</span>
              <i class="material-icons" [ngClass]="{'active':isRegistrationTypeAsc}"> arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('hotelStatus', $event)">
              <span>Hotel Status</span>
              <i class="material-icons" [ngClass]="{'active':isHotelStatusAsc}">arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('courseStatus', $event)">
              <span>Course Status</span>
              <i class="material-icons" [ngClass]="{'active':isCourseStatusAsc}">arrow_drop_down</i>
            </th>
            <th class="last-view">
              <div>
                <div>
                  <span>Start Date</span>
                  <i class="material-icons">arrow_drop_down</i>
                </div>
                <div>
                  <span>End Date</span>
                  <i class="material-icons">arrow_drop_down</i>
                </div>
                <div>
                  <span>Room Type</span>
                  <i class="material-icons">arrow_drop_down</i>
                </div>
                <div>
                  <span>Date Added</span>
                  <i class="material-icons">arrow_drop_down</i>
                </div>
              </div>
            </th>
          </thead>
          <tbody>
            @for (participant of getDisplayParticipants(); track trackParticipant($index, participant)) {
              <tr [ngClass]="{'selected-row': isSelected(participant), 'hidden-row': isParticipantHidden(participant)}">
                <td class="edit select-visibility-col">
                  <div>
                    <input type="checkbox" [checked]="isSelected(participant)" [disabled]="isPrivacyNotApplicable(participant)"
                      (change)="toggleSelection(participant)" />
                    @if (isPrivacyNotApplicable(participant)) {
                      <span class="visibility-na" title="Not applicable — non-Cvent registration">N/A</span>
                    } @else {
                      <button type="button" class="visibility-icon-btn"
                        [ngClass]="isParticipantHidden(participant) ? 'is-hidden' : 'is-visible'"
                        [disabled]="!canToggleIndividualVisibility(participant)"
                        (click)="toggleParticipantVisibility(participant)"
                        [attr.aria-label]="isParticipantHidden(participant) ? 'Hidden from attendee lists' : 'Visible in attendee lists'"
                        [title]="!canToggleIndividualVisibility(participant)
                          ? 'Clear selection to change visibility individually'
                          : (isParticipantHidden(participant) ? 'Hidden — click to show in attendee lists' : 'Visible — click to hide from attendee lists')">
                        <mat-icon>{{ isParticipantHidden(participant) ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>
                    }
                  </div>
                </td>
                <td class="name edit">
                  <div>
                    <div><span></span></div>
                    <span>{{participant?.lastName}}, {{participant?.firstName}}</span>
                  </div>
                </td>
                <td class="edit">
                  <div>
                    <span>{{participant?.email}}</span>
                  </div>
                </td>
                <td class="edit">
                  @if (participant?.flightArrival) {
                    <div>
                      <span>{{participant?.flightArrival | dateFormat : 'll'}}</span> <br>
                    </div>
                    <div class="m-t-xs ">
                      <span class="text-gray-light font-size-14 font-weight-bold">{{participant?.flightArrival | timeFormat}} ET</span>
                    </div>
                  } @else {
                    <div>
                      <span>Not Booked</span> <br>
                    </div>
                  }
                </td>
                <td class="view">
                  <div>
                    <span>{{participant?.lastName}}, {{participant?.firstName}}</span>
                    <span>{{participant?.email}}</span>
                  </div>
                </td>
                <td class="default">
                  <div>
                    <span>{{(participant?.hotel?.booking)?.startDate | dateFormat : 'registrationdate'}}</span>
                    <span>{{(participant?.hotel?.booking)?.endDate | dateFormat : 'registrationdate'}}</span>
                    <span>{{(participant?.hotel?.booking)?.roomType}}</span>
                    <span><span> <span>{{(participant?.hotel?.booking)?.requestDate | dateFormat : 'registrationdate'}}</span> </span>
                    </span>
                  </div>
                </td>
                <td class="edit">
                  @if (participant?.flightDeparture) {
                    <div>
                      <span>{{participant?.flightDeparture | dateFormat : 'll'}}</span> <br>
                    </div>
                    <div class="m-t-xs ">
                      <span class="text-gray-light font-size-14 font-weight-bold">{{participant?.flightDeparture | timeFormat}} ET</span>
                    </div>
                  } @else {
                    <div>
                      <span>Not Booked</span> <br>
                    </div>
                  }
                </td>
                <td class="edit">
                  <div>
                    <span>{{participant?.inviteeStatus}}</span>
                  </div>
                </td>
                <td class="edit">
                  <div>
                    <span>{{participant?.registrationType}}</span>
                  </div>
                </td>
                <td class="edit status">
                  <div class="font-size-15">
                    <span class="{{participant?.hotelStatus | statuscolor }} ">{{participant?.hotelStatus}}</span>
                  </div>
                </td>
                <td class="edit">
                  <div>
                    <span>{{participant?.courseStatus}}</span>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <p class="background-white m-t-xs noResults">
          <span class="m-l-lg">
            <error-message [errorMessage]="errorMessage"></error-message>
          </span>
        </p>
      }
    </div>
  </div>
} @else {
  @if (!showLoading) {
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  }
}

@if (showLoading) {
  <div class="registration-loading">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
